import { ComponentLoader } from '@Component';
import InViewAni from '@Core/components/inViewAni';
import InViewSrc from '@Core/components/inViewSrc';
import InViewSrcset from '@Core/components/inViewSrcset';
import InViewStyle from '@Core/components/inViewStyle';
import TitleCard from '@Core/components/titleCard';
import Accordion from '@Core/components/accordion';
import Modal from '@Core/components/microModalAdpt';
import Slideshow from '@Core/components/sliders/slideshow';
import SectionGeneralSlider from '@Core/components/sliders/sectionGeneralSlider';
import SectionPhotoCarousel from '@Core/components/sliders/sectionPhotoCarousel';
import AdventureVanMenu from '@Core/components/AdventureVanMenu';
import MobileMenuToggle from '@Core/components/mobileNavToggle';
import XhrForm from '@Core/components/xhrForm';
import SectionVerticalSlider from '@Core/components/sliders/sectionVerticalSlider';
import Subnavigation from '@Core/components/subnavigation';
import SectionInstagramSlider from '@Core/components/sliders/sectionInstagramSlider';
import Matterport from '@Core/components/matterport';
import BlogIndex from '@Core/components/blogIndex';
import TrackEvent from '@Core/components/trackEvent';
import VanOrderForm from '@Core/components/vanOrderForm';
import SpecificationsTable from '@Core/components/specificationsTable';
import YouTubePlayerWrapper from '@Core/components/youTubePlayerWrapper';

window.globalComponents = new ComponentLoader(document, [
  InViewAni,
  InViewSrc,
  InViewSrcset,
  InViewStyle,
  TitleCard,
  Accordion,
  Modal,
  Slideshow,
  SectionGeneralSlider,
  SectionPhotoCarousel,
  AdventureVanMenu,
  MobileMenuToggle,
  XhrForm,
  SectionVerticalSlider,
  Subnavigation,
  SectionInstagramSlider,
  Matterport,
  BlogIndex,
  TrackEvent,
  VanOrderForm,
  SpecificationsTable,
  YouTubePlayerWrapper,
]);
